 <div class="background page-wrap" >
  <mat-card class="center-card">
    <mat-card-title>
      <span>Dash Account Not Found</span>
    </mat-card-title>
    <mat-card-content>
      <div class="pb-1">
        Your login to the Pinnacle Domain was successful, but the Dash Server cannot find your account.
        Please speak to your manager to add you to the dash users.
      </div>
      <button mat-raised-button class="mat-primary full-width mb-1" [routerLink]="['/sessions/signin']">Try
        Again</button>
    </mat-card-content>
  </mat-card>
</div>